"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datetimeFormatter = datetimeFormatter;
const baseConfig = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: undefined,
    minute: undefined
};
const hasTimeZoneRegexp = new RegExp(/T|Z/gi);
/***
 * Date Time formatter from ISO to CLIC format
 * @param date ISO date or datetime
 * @return MM/dd/yyyy HH:mm or MM/dd/yyyy
 */
function datetimeFormatter(dateStr) {
    const tempDate = new Date(dateStr);
    const date = hasTimeZoneRegexp.test(dateStr)
        ? new Date(dateStr)
        : new Date(tempDate.valueOf() + tempDate.getTimezoneOffset() * 60 * 1000);
    if (dateStr.length > 10) {
        return date
            .toLocaleDateString('en-US', Object.assign(Object.assign({}, baseConfig), { hour: '2-digit', minute: '2-digit', hour12: false }))
            .replace(',', ''); // MM/dd/yyyy HH:mm
    }
    else {
        return date.toLocaleDateString('en-US', baseConfig); // MM/dd/yyyy
    }
}
